package uz.mint.frontend

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier

/**
 * Flexbox/grid shorthands written as raw CSS properties.
 *
 * Kobweb and Compose HTML each export their own `AlignItems`, `JustifyContent` and `FlexWrap`,
 * and the matching `Modifier` extensions overload across both — importing either package
 * wholesale makes every call site ambiguous. Emitting the property directly sidesteps that
 * entirely and reads closer to the design, which is plain CSS to begin with.
 */
fun Modifier.alignItems(value: String) = styleModifier { property("align-items", value) }
fun Modifier.justifyContent(value: String) = styleModifier { property("justify-content", value) }
fun Modifier.alignSelf(value: String) = styleModifier { property("align-self", value) }
fun Modifier.flexWrapCss(value: String = "wrap") = styleModifier { property("flex-wrap", value) }
fun Modifier.flexDirectionCss(value: String) = styleModifier { property("flex-direction", value) }
fun Modifier.placeItems(value: String) = styleModifier { property("place-items", value) }

/** Centres a fixed-width block horizontally. */
fun Modifier.marginInlineAuto() = styleModifier { property("margin-inline", "auto") }

/** Arbitrary width expression — lets `min()`/`clamp()` come straight from the design. */
fun Modifier.widthCss(expression: String) = styleModifier { property("width", expression) }

fun Modifier.gridTemplateColumnsCss(expression: String) =
    styleModifier { property("grid-template-columns", expression) }

/**
 * Breaks anywhere, including mid-token.
 *
 * For the eSIM activation string: an LPA line is one long unbroken token, and without this it
 * pushes its card wider than the viewport and gives the whole page a horizontal scrollbar.
 */
fun Modifier.wordBreakAll() = styleModifier { property("word-break", "break-all") }
